import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Visit } from '../models/visit.model';

@Injectable({
  providedIn: 'root'
})
export class VisitService {


  apiUrl = environment.apiUrl;
  private visitSource = new ReplaySubject<any>(1);
  private paginationSource = new ReplaySubject<any>(1);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  visit$ = this.visitSource.asObservable();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  paginationSettings$ = this.paginationSource.asObservable();

  constructor(private http: HttpClient) { }

  getVisitById(visitId: number) {
    return this.http.get(this.apiUrl + 'api/Visit/' + visitId)
  }

  getVisitByCardId(cardId: string) {
    return this.http.get(this.apiUrl + 'api/Visit/GetByCardId/' + cardId)
  }

  getVisitQrCode(code: string) {
    return this.http.get(this.apiUrl + 'api/Visit/VisitCode/' + code)
  }

  printQrCode(code: string) {
    return this.http.get(this.apiUrl + 'api/Visit/PrintVisitQrCode/' + code, { responseType: 'arraybuffer' })
  }

  getAllVisits(queryParams = { currentPage: null, itemsPerPage: null, fullNameQuery: '', StatusQuery: '', phoneQuery: '' }) {
    let params = new HttpParams();
    params = params.append('fullNameQuery', queryParams.fullNameQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    params = params.append('phoneQuery', queryParams.phoneQuery);


    return this.http.get(this.apiUrl + 'api/Visit/SearchVisits', { params, observe: 'response' }).pipe(map((res: any) => {

      if (res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.visitSource.next(res.body);
      }
    })).toPromise();
  }

getAllVisitsAdminManagerRoleDirect(queryParams = {
  currentPage: 1, itemsPerPage: 20, fullNameQuery: '', birthDateQuery: '', roomQuery: '',
  statusQuery: '', dateQuery: '', dateQueryEnd: '', enterTimeQuery: '', enterTimeQueryEnd: '',
  timeZoneQuery: '', gratisQuery: '', packageTicketType: ''
}) {
  let params = new HttpParams();
  params = params.append('fullNameQuery', queryParams.fullNameQuery);
  params = params.append('birthDateQuery', queryParams.birthDateQuery);
  params = params.append('roomQuery', queryParams.roomQuery);
  params = params.append('statusQuery', queryParams.statusQuery);
  params = params.append('dateQuery', queryParams.dateQuery);
  params = params.append('dateQueryEnd', queryParams.dateQueryEnd);
  params = params.append('enterTimeQuery', queryParams.enterTimeQuery);
  params = params.append('enterTimeQueryEnd', queryParams.enterTimeQueryEnd);
  params = params.append('timeZoneQuery', queryParams.timeZoneQuery);
  params = params.append('gratisQuery', queryParams.gratisQuery);
  params = params.append('packageTicketType', queryParams.packageTicketType);
  params = params.append('pageNumber', queryParams.currentPage);
  params = params.append('pageSize', queryParams.itemsPerPage);

  return this.http.get<Visit[]>(this.apiUrl + 'api/Visit/SearchVisitsAdminRole', { params, observe: 'response' })
    .pipe(
      map((res: any) => {
        const pagination = JSON.parse(res.headers.get('pagination'));
        return {
          visits: res.body as Visit[],
          pagination
        };
      })
    );
}

getAllVisitsByParentId(queryParams = {
  currentPage: 1, itemsPerPage: 20, parentIdQuery: ''}) {
  let params = new HttpParams();
  params = params.append('parentIdQuery', queryParams.parentIdQuery);
  params = params.append('pageNumber', queryParams.currentPage);
  params = params.append('pageSize', queryParams.itemsPerPage);

  return this.http.get<Visit[]>(this.apiUrl + 'api/Visit/SearchVisitsAdminRole', { params, observe: 'response' })
    .pipe(
      map((res: any) => {
        const pagination = JSON.parse(res.headers.get('pagination'));
        return {
          visits: res.body as Visit[],
          pagination
        };
      })
    );
}




  getAllVisitsAdminManagerRole(queryParams = {
    currentPage: 1, itemsPerPage: 20, fullNameQuery: '', birthDateQuery: '', roomQuery: '',
    statusQuery: '', dateQuery: '', dateQueryEnd: '', enterTimeQuery: '', enterTimeQueryEnd: '', timeZoneQuery: '', gratisQuery:'', packageTicketType: ''
  }) {
    let params = new HttpParams();
    params = params.append('fullNameQuery', queryParams.fullNameQuery);
    params = params.append('birthDateQuery', queryParams.birthDateQuery);
    params = params.append('roomQuery', queryParams.roomQuery);
    params = params.append('statusQuery', queryParams.statusQuery);
    params = params.append('dateQuery', queryParams.dateQuery);
    params = params.append('dateQueryEnd', queryParams.dateQueryEnd);
    params = params.append('enterTimeQuery', queryParams.enterTimeQuery);
    params = params.append('enterTimeQueryEnd', queryParams.enterTimeQueryEnd);
    params = params.append('timeZoneQuery', queryParams.timeZoneQuery);
    params = params.append('gratisQuery', queryParams.gratisQuery);
    params = params.append('packageTicketType', queryParams.packageTicketType);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    return this.http.get(this.apiUrl + 'api/Visit/SearchVisitsAdminRole', { params, observe: 'response' }).pipe(map((res: any) => {

      if (res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.visitSource.next(res.body);
      }
    })).toPromise();
  }

  addVisit(visit: Visit, phone: string, email: string, cardType: number, hours: number,gratis:boolean, packageTicketType: boolean) {
    return this.http.post(this.apiUrl + 'api/Visit/Checkin', { visitorId: visit.id, phoneVisit: phone, emailVisit: email, cardType: cardType, hours: hours, Gratis:gratis,
       packageTicketType: packageTicketType }
      , { responseType: 'arraybuffer' }
    );


    /*    const formData = new FormData();
       formData.append("visitorId", visit.id.toString());
       formData.append("cardId",cardId);
       formData.append("phoneVisit", phone);
       formData.append("emailVisit",email);
       formData.append('ImageQr', ImageQr, `test.pdf`)
        return this.http.post(this.apiUrl + 'api/Visit/Checkin', formData); */
  }

  addVisitWithoutHours(visit: Visit, phone: string, email: string, cardType: number, gratis:boolean, packageTicketType: boolean) {
    return this.http.post(this.apiUrl + 'api/Visit/Checkin', { visitorId: visit.id, phoneVisit: phone, emailVisit: email, cardType: cardType ,Gratis:gratis, 
      packageTicketType: packageTicketType},
      { responseType: 'arraybuffer' }
    );
  }


  editCheckin(visit) {
    return this.http.put(`${this.apiUrl}api/Visit/${visit.id}`, visit);
  }

  exportCSV(queryParams = {
    currentPage: 1, itemsPerPage: 20, pageSize: 2147483647, fullNameQuery: '', birthDateQuery: '', roomQuery: '',
    statusQuery: '', dateQuery: '', dateQueryEnd: '', enterTimeQuery: '', enterTimeQueryEnd: '', gratisQuery:'', packageTicketType: ''
  }) {
    let params = new HttpParams();
    params = params.append('fullNameQuery', queryParams.fullNameQuery);
    params = params.append('birthDateQuery', queryParams.birthDateQuery);
    params = params.append('roomQuery', queryParams.roomQuery);
    params = params.append('statusQuery', queryParams.statusQuery);
    params = params.append('dateQuery', queryParams.dateQuery);
    params = params.append('dateQueryEnd', queryParams.dateQueryEnd);
    params = params.append('enterTimeQuery', queryParams.enterTimeQuery);
    params = params.append('enterTimeQueryEnd', queryParams.enterTimeQueryEnd);
    params = params.append('gratisQuery', queryParams.gratisQuery);
    params = params.append('packageTicketType', queryParams.packageTicketType);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.pageSize);
    return this.http.get(this.apiUrl + 'api/Visit/exportCSV', { params, responseType: "text" })
  }


  getAllBlockedVisits(queryParams = { currentPage: 1, itemsPerPage: 20, fullNameBlockedVisitorsQuery: '' }) {
    let params = new HttpParams();
    params = params.append('fullNameBlockedVisitorsQuery', queryParams.fullNameBlockedVisitorsQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    return this.http.get(this.apiUrl + 'api/Visit/SearchBlockedVisits', { params, observe: 'response' }).pipe(map((res: any) => {

      if (res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.visitSource.next(res.body);
      }
    })).toPromise();
  }

  editVisitSurcharge(visit) {
    return this.http.put(`${this.apiUrl}api/Visit/VisitSurcharge/${visit.id}`, visit);
  }

}
